
///<reference path="./IController.ts"/>
///<reference path="../event/ControllerEvent.ts"/>
///<reference path="../model/AppState.ts"/>
///<reference path="../view/parts/HorizontalScroller.ts"/>
///<reference path="../view/parts/HistoryClock.ts"/>
///<reference path="../view/parts/PageUpButton.ts"/>
///<reference path="../view/parts/scroll/ScrollObjectBase.ts"/>
///<reference path="../view/parts/scroll/FadeMotionObject.ts"/>
///<reference path="../view/parts/scroll/MaskObject.ts"/>
///<reference path="../view/parts/YoutubeController.ts"/>
///<reference path="../view/parts/card/CardController.ts"/>

namespace khi.bk117.control
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Debugger = com.enirva.debug.Debugger;
	import UserAgent = com.enirva.util.UserAgent;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;

	import AppState = khi.bk117.model.AppState;
	import IController = khi.bk117.control.IController;
	import ControllerEvent = khi.bk117.event.ControllerEvent;
	import HistoryClock = khi.bk117.view.parts.HistoryClock;
	import PageUpButton = khi.bk117.view.parts.PageUpButton;
  import ScrollObjectBase = khi.bk117.view.parts.scroll.ScrollObjectBase;
  import FadeMotionObject = khi.bk117.view.parts.scroll.FadeMotionObject;
	import MaskObject = khi.bk117.view.parts.scroll.MaskObject;
	import HorizontalScroller = khi.bk117.view.parts.HorizontalScroller;
	import YoutubeController = khi.bk117.view.parts.YoutubeContainer;
	import CardController = khi.bk117.view.parts.card.CardController;

	export class Controller extends EventDispatcher implements IController
	{
		private historyClock:HistoryClock;
		
		private finishScrollItem:boolean;
		
		private items:ScrollObjectBase[];
		
		private pageUp:PageUpButton;

		private youtubeController:YoutubeController;

		constructor()
		{
			super();
			this.historyClock = new HistoryClock();
			this.pageUp = new PageUpButton();

			AppState.Initialize();

			this.items = [];

			$(".sec03 .scrollContainerSp .scrollBody").append($(".sec03 .scrollContainerPc").clone().removeClass("scrollContainerPc"));

			$(".sec03 .scrollContainerSp .scrollBody .item").each((index:number, elem:Element):void=>
			{
				$(elem).removeClass("FADER");
			});

			//フェードオブジェクト
      $(".FADER").each((index:number, elem:Element)=>
      {
        var item:ScrollObjectBase = new FadeMotionObject($(elem));
        this.items.push(item);
      });
      $(".MASK").each((index:number, elem:Element)=>
      {
        var item:ScrollObjectBase = new MaskObject($(elem));
        this.items.push(item);
			});

			const s:HorizontalScroller = new HorizontalScroller(".sec03 .scrollContainerSp .scrollBody", 1, false, ".sec03 .scrollContainerSp .scrollContainerArrow");
			s.start();

			let isSp:boolean = true;

			if (UserAgent.instance.isTablet)
			{
				isSp = false;
			}
			else if (!UserAgent.instance.isIOS && !UserAgent.instance.isAndroid)
			{
				isSp = false;
			}

			/*
			let w:number = 960;
			let h:number = 540;
			const per:number = h / w;
			
			if (isSp)
			{
				w = AppState.stageWidth - 40;
				h = w * per;
			}
			*/

			this.youtubeController = new YoutubeController(/*w, h*/);

			//if (isModal)
			//{
				$(".YOUTUBE").each((index:number, elem:Element):void =>
				{
					const cls:string[] = $(elem).attr("class").split(" ");
					let url:string = "";
	
					for (var i:number = 0; i < cls.length; i++)
					{
						if (cls[i].indexOf("URL_") >= 0)
						{
							url = cls[i].replace("URL_", "");
							break;
						}
					}
	
					$(elem).on("click", ()=>
					{
						console.log("click " + url);
						
						let w:number = 960;
						let h:number = 540;
						const per:number = h / w;
						
						if (AppState.stageWidth < 1000)
						{
							w = AppState.stageWidth - 40;
							h = w * per;
						}
						
						this.youtubeController.open(url, w, h);
					});
				});
	
				$(".youtubeContainer .btnContainer a").on("click", ()=>
				{
					this.youtubeController.close();
				});
			//}

			this.startContents();
			
			const cardController:CardController = new CardController();

			window.setTimeout(()=>
			{
				cardController.showCard();
	
				$(".sec360").on("click", ()=>
				{
					//console.log("sec 360");
					
					$(".view360Container").fadeIn(300, ()=>
					{
						//YoutubeControllerのスクロール停止フラグを利用
						YoutubeController.canScroll = false;
	
					});
				});
	
				$(".view360Container .btnContainer").on("click", ()=>
				{
					//YoutubeControllerのスクロール停止フラグを利用
					YoutubeController.canScroll = true;

					$(".view360Container").fadeOut(300, ()=>
					{
	
					});
				});
			}, 700);

			/*
			window.addEventListener("bk117SwitchTopDisplay", ()=>
			{
				cardController.showCard();
			});
			*/
			//new CardController();
		}


		public notify(event:ControllerEvent):void
		{
			/*
			 */
			switch (event.type)
			{
				case ControllerEvent.RE_SET_PJAX:
					break;
				default:break;
			}
		}


		private startContents():void
		{
			this.onEnterFrame = ()=>
			{
				const sc:number = AppState.scrollPosition;
				const h:number = AppState.stageHeight;

				this.historyClock.update(sc, h);

        var curr:number = AppState.scrollPosition;
        var center = curr + (h * 0.7);
				let allFinish:boolean = true;
				
				this.pageUp.check(curr, h);

        if (!this.finishScrollItem)
        {
          //スクロールオブジェクト監視
          for (var i:number = 0, ln:number = this.items.length; i < ln; i++)
          {
            this.items[i].update(curr, h);
  
            if (!this.items[i].isShow)
            {
              allFinish = false;
            }
          }
        }
			};
		}
	}
}

